<template>
<v-list-tile-sub-title class="black--text">
  <div v-if="isTemperatureShown"><b>{{ temperatureCelsius }}</b> <small class="grey--text">°C</small> <b class="ml-3">{{ temperatureFahrenheit }}</b> <small class="grey--text">°F</small></div>
  <div v-if="isMeterShown"><b>{{ eventlog.meter.watt/10 }}</b> <small class="grey--text">W</small> <b class="ml-3">{{ eventlog.meter.kwh/100 }}</b> <small class="grey--text">kWh</small></div>
  <div v-if="isMeterSwitchShown">{{ statusSwitch ? $t(statusSwitch) : '---' }}<b class="ml-3">{{ eventlog.meter.watt/10 }}</b> <small class="grey--text">W</small> <b class="ml-2">{{ eventlog.meter.kwh/100 }}</b> <small class="grey--text">kWh</small>
  </div>
  <div v-if="isSensorValueShown"><b>{{ eventlog.sensorvalue }}</b> <small class="grey--text">{{ displaySensorUnit }}</small></div>
  <div v-if="isBasicValueShown"><b>{{ Math.min(eventlog.basicvalue,100) }}</b> <small class="grey--text">%</small></div>
  <div v-if="isColorDimmerShown">
    <v-chip :color="colorColorDimmer" class="px-1 my-0 ml-0 mr-2" style="height:16px !important"></v-chip><b>{{ Math.min(eventlog.basicvalue,100) }}</b> <small class="grey--text">%</small>
  </div>
  <div v-if="isTimestampShown">{{ smartTimestamp }}</div>
  <div v-if="isDoorSensorShown">{{ statusDoor ? $t(statusDoor) : '---' }}</div>
  <div v-if="isFloodShown">{{ statusFlood ? $t(statusFlood) : '---' }}</div>
  <div v-if="isGlassShown">{{ statusGlass ? $t(statusGlass) : '---' }}</div>
  <div v-if="isSwitchShown">{{ statusSwitch ? $t(statusSwitch) : '---' }}</div>
  <div v-if="isLockShown">{{ statusLock ? $t(statusLock) : '---' }}</div>
  <div v-if="isFanShown">{{ statusFan ? $t(statusFan) : '---' }}</div>
  <div v-if="isModeShown">{{ statusMode ? $t(statusMode) : '---' }}</div>
</v-list-tile-sub-title>
</template>

<script>
const units = require('./DeviceUnits');
const categoryLabels = require('./DeviceLabels');

module.exports = {
  name: 'DeviceValue',
  props: {
    item: {
      type: Object,
      required: true
    },
    eventlog: {
      type: Object,
      required: true
    }
  },
  computed: {
    isTemperatureShown() {
      return [11, 34].includes(this.item.functype) && this.eventlog.sensorvalue != undefined;
    },
    temperatureCelsius() {
      let t = this.eventlog.sensorvalue * 0.1;
      if (t) {
        if (this.eventlog.unit == 2)
          t = (t - 32) * 5 / 9;
        return t.toFixed(1);
      }
      return '---';
    },
    temperatureFahrenheit() {
      let t = this.eventlog.sensorvalue * 0.1;
      if (t) {
        if (this.eventlog.unit == 1) t = t * 9 / 5 + 32;
        return t.toFixed(0);
      }
      return '---';
    },
    isSensorValueShown() {
      return [12, 15, 40].includes(this.item.functype) && this.eventlog.sensorvalue != undefined;
    },
    displaySensorUnit() {
      return units.names[this.eventlog.unit];
    },
    isTimestampShown() {
      return [14, 28].includes(this.item.functype) && this.eventlog.timestamp;
    },
    isDoorSensorShown() {
      return this.item.functype == 13 && this.eventlog.basicvalue != undefined;
    },
    statusDoor() {
      return categoryLabels[13][this.eventlog.basicvalue > 0 ? 100 : 0];
    },
    isFloodShown() {
      return [17, 20, 25].includes(this.item.functype) && this.eventlog.basicvalue != undefined;
    },
    statusFlood() {
      return categoryLabels[20][this.eventlog.basicvalue > 0 ? 100 : 0];
    },
    isGlassShown() {
      return this.item.functype == 21 && this.eventlog.basicvalue != undefined;
    },
    statusGlass() {
      return categoryLabels[21][this.eventlog.basicvalue > 0 ? 100 : 0];
    },
    isSwitchShown() {
      return [23, 36].includes(this.item.functype) && this.eventlog.basicvalue != undefined;
    },
    statusSwitch() {
      return categoryLabels[23][this.eventlog.basicvalue > 0 ? 100 : 0];
    },
    isBasicValueShown() {
      return [24, 26, 30].includes(this.item.functype) && this.eventlog.basicvalue != undefined;
    },
    isColorDimmerShown() {
      return [41].includes(this.item.functype) && this.eventlog.basicvalue != undefined && this.eventlog.switch_color != undefined;
    },
    isLockShown() {
      return this.item.functype == 31 && this.eventlog.basicvalue != undefined;
    },
    statusLock() {
      return categoryLabels[31][this.eventlog.basicvalue > 0 ? 100 : 0];
    },
    isFanShown() {
      return this.item.functype == 32 && this.eventlog.sensorvalue != undefined;
    },
    statusFan() {
      return categoryLabels[32][this.eventlog.sensorvalue];
    },
    isModeShown() {
      return this.item.functype == 33 && this.eventlog.sensorvalue != undefined;
    },
    statusMode() {
      return categoryLabels[33][this.eventlog.sensorvalue];
    },
    isMeterShown() {
      return [29].includes(this.item.functype) && this.eventlog.meter;
    },
    isMeterSwitchShown() {
      return [22].includes(this.item.functype) && this.eventlog.meter;
    },
    smartTimestamp() {
      let now = new Date();
      let dt = new Date(this.eventlog.timestamp * 1000);
      if (now.toLocaleDateString() == dt.toLocaleDateString())
        return dt.toLocaleTimeString()
      else
        return dt.toLocaleString()
    },
    colorColorDimmer() {
      let sc = (this.eventlog.switch_color || {}).comp_value || [];
      let r = sc[2].value || 0;
      let g = sc[3].value || 0;
      let b = sc[4].value || 0;
      return `rgba(${r},${g},${b},1.0)`;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/device/DeviceValue.vue